import IconPrev from '@mui/icons-material/ChevronLeft'
import IconNext from '@mui/icons-material/ChevronRight'
import styles from './WeekNav.pcss'
import { CalendarDay } from 'interfaces/Post/Calendar'
import { format } from 'date-fns'

interface WeekNavProps {
  days: CalendarDay[]
  withBackNav: boolean
  withForwardNav?: boolean
  className?: string
  onNext: () => void
  onPrev: () => void
}

export function WeekNav({ days, withBackNav, withForwardNav = true, className, onNext, onPrev }: WeekNavProps) {
  const labelFrom = format(days[0].date, 'MMM d')
  const labelTo = format(days[6].date, 'MMM d') // eslint-disable-line no-magic-numbers

  return (
    <div className={`${styles.nav} ${className || ''}`}>
      <div className={styles.selection}>
        {(withBackNav) && (
          <IconPrev className={styles['btn-nav']} role="button" data-testid="week-nav-prev" onClick={onPrev} />
        )}
        <div className={styles.active}>
          {`${labelFrom} - ${labelTo}`}
        </div>
        {withForwardNav && (
          <IconNext className={styles['btn-nav']} role="button" data-testid="week-nav-next" onClick={onNext} />
        )}
      </div>
    </div>
  )
}

export default WeekNav
